import { useEffect, useState } from 'react';
import MoonIcon from '@/assets/moon.svg?react';
import SunIcon from '@/assets/sun.svg?react';
import Button, { ButtonProps } from './Button';
import useStore from '@/store/CreateStore';

const ThemeSwitch = (props: ButtonProps) => {
  const [dark, setDark] = useState(true);

  const userId = useStore((state) => state.room.userId);
  const presenterId = useStore((state) => state.room.presenterId);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', dark);
  }, [dark]);

  return (
    <Button
      Icon={dark ? MoonIcon : SunIcon}
      iconProps={{ className: 'fill-current' }}
      onClick={() => setDark((s) => !s)}
      tooltip={{
        text: dark ? 'Dark mode' : 'Light Mode',
        position: userId === presenterId ? 'right' : 'left'
      }}
      data-name="theme_toggled"
      {...props}
    />
  );
};
export default ThemeSwitch;
